export default {
  "b2b.provozni-informace-posledni-widget.label":
    "Last operational information",
  "b2b.provozni-informace-posledni-widget.cardNext": "NEXT"
};
